var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42859 16C3.33244 16 0 12.6675 0 8.57141C0 4.47529 3.33244 1.14282 7.42859 1.14282C11.5247 1.14282 14.8571 4.47527 14.8571 8.57141C14.8571 12.6676 11.5247 16 7.42859 16Z",
    fill: "#FDBF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1659 10.338H5.90626C5.71158 10.338 5.54054 10.2087 5.48747 10.0213L4.68323 7.1824C4.64043 7.03128 4.68236 6.86883 4.79295 6.75729C4.90354 6.64577 5.06563 6.60245 5.21711 6.64397L6.53366 7.0049L7.69619 5.5022C7.77863 5.39564 7.90576 5.33325 8.04046 5.33325C8.17516 5.33325 8.30229 5.39564 8.38473 5.5022L9.54725 7.0049L10.8637 6.64397C11.0155 6.60239 11.1778 6.64586 11.2883 6.75772C11.3989 6.86956 11.4406 7.03238 11.3973 7.18359L10.5844 10.0225C10.5309 10.2093 10.3601 10.338 10.1659 10.338Z",
    fill: "#252529"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14_4164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.76184 14.8571C4.6657 14.8571 1.33325 11.5247 1.33325 7.42859C1.33325 3.33247 4.6657 0 8.76184 0C12.858 0 16.1904 3.33244 16.1904 7.42859C16.1904 11.5247 12.858 14.8571 8.76184 14.8571Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8324 9.67148H6.57276C6.37808 9.67148 6.20705 9.54217 6.15397 9.35483L5.34974 6.5159C5.30693 6.36477 5.34887 6.20233 5.45945 6.09078C5.57004 5.97927 5.73214 5.93594 5.88361 5.97747L7.20017 6.3384L8.36269 4.83569C8.44513 4.72914 8.57226 4.66675 8.70696 4.66675C8.84166 4.66675 8.96879 4.72914 9.05123 4.83569L10.2138 6.3384L11.5303 5.97747C11.682 5.93589 11.8443 5.97935 11.9548 6.09122C12.0654 6.20306 12.1071 6.36588 12.0638 6.51709L11.2509 9.35602C11.1974 9.54275 11.0266 9.67148 10.8324 9.67148Z",
    fill: "#252529"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14_4164",
    x: -0.566748,
    y: -1.9,
    width: 18.6572,
    height: 18.6572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14_4164"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14_4164",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitCoin);
export default __webpack_public_path__ + "static/media/submit_coin.4e3ed9ea44f6bdcc12482a61bc4065de.svg";
export { ForwardRef as ReactComponent };